import { DateTime } from 'luxon';
import moment from 'moment';

export type DateDuration = {
  days?: number;
  months?: number;
  years?: number;
};

export const formatDate = (ISODate: string, format: string = 'dd LLL yyyy') => {
  return DateTime.fromISO(ISODate).toFormat(format);
};

export const formatJSDate = (date: Date, format = 'yyyy-MM-dd') =>
  fromJS(date).toFormat(format);

export const dateStringToLocalYMD = (ds?: string) => {
  if (!ds) return undefined;

  const [year, month, date] = ds.split('-').map(Number);
  return DateTime.local(year, month, date).toJSDate();
};

export const fromISO = (str: string) => DateTime.fromISO(str);
export const fromJS = (d: Date) => DateTime.fromJSDate(d);

export const getMomentDate = (dateString: string) => {
  return moment(dateString);
};

export const getMonthAndDayName = (ds: string) => {
  const date = DateTime.fromISO(ds);

  return { month: date.monthLong, day: date.day };
};
